export interface ServiceItem {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const services: ServiceItem[] = [
  {
    id: 'svc-1',
    title: '亚洲影视',
    description: '汇聚中日韩及东南亚热门影视资源，最新剧集、经典电影、独家纪录片，随时随地畅享亚洲精彩视听盛宴。',
    icon: 'ri-movie-2-line',
  },
  {
    id: 'svc-2',
    title: '在线购物',
    description: '连接亚洲顶级电商平台，从日本药妆到韩国美妆，从中国数码到东南亚特产，一站逛遍全亚洲好物。',
    icon: 'ri-shopping-bag-3-line',
  },
  {
    id: 'svc-3',
    title: '亚洲资讯',
    description: '实时追踪亚洲各国热点新闻、财经动态、科技进展和文化趋势，让您掌握亚洲脉搏，洞悉区域机遇。',
    icon: 'ri-newspaper-line',
  },
  {
    id: 'svc-4',
    title: '数字生活',
    description: '探索亚洲前沿数字生活方式，移动支付、智慧出行、在线教育、远程办公，解锁高效便捷的数字新体验。',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'svc-5',
    title: '语言服务',
    description: '提供中日韩越泰等多语种翻译与学习资源，打破语言壁垒，让亚洲各国人民沟通零距离。',
    icon: 'ri-translate-2',
  },
  {
    id: 'svc-6',
    title: '旅游出行',
    description: '精选亚洲热门旅游目的地攻略，从东京到巴厘岛，从首尔到曼谷，让您的亚洲之旅轻松无忧。',
    icon: 'ri-flight-takeoff-line',
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const stats: StatItem[] = [
  { value: '5000万+', label: '月活跃用户' },
  { value: '12个', label: '覆盖国家与地区' },
  { value: '10万+', label: '优质内容资源' },
  { value: '99.9%', label: '平台可用率' },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '亚洲在线平台提供哪些类型的内容与服务？',
    answer: '亚洲在线平台提供涵盖影音娱乐、在线购物、亚洲资讯、数字生活、科技前沿和旅游出行六大板块的丰富内容。您可以在平台上浏览最新亚洲影视资讯、了解电商购物趋势、获取亚洲各国新闻动态，以及探索前沿科技和旅行攻略。',
  },
  {
    question: '平台内容是否免费？需要注册账号吗？',
    answer: '亚洲在线的绝大多数内容均可免费浏览。浏览资讯和文章无需注册账号即可直接访问。部分高级功能和个性化推荐服务可能需要注册免费会员账号，注册过程简单快捷，只需邮箱即可完成。',
  },
  {
    question: '平台覆盖哪些亚洲国家和地区的内容？',
    answer: '亚洲在线全面覆盖东亚（中国、日本、韩国）、东南亚（新加坡、马来西亚、泰国、越南、印度尼西亚、菲律宾）和南亚（印度）等主要国家和地区，为您呈现最全面、最及时的亚洲数字生活图景。',
  },
  {
    question: '如何获取最新的内容更新通知？',
    answer: '您可以通过订阅我们的邮件通知服务，第一时间获取最新内容和行业动态。在网站底部的订阅区域输入您的邮箱地址即可完成订阅。我们承诺不会向您发送垃圾邮件，每周最多推送1-2次精选内容摘要。',
  },
  {
    question: '平台上的购物服务如何运作？',
    answer: '亚洲在线作为信息聚合平台，为您汇集亚洲各大电商平台的热门商品和优惠信息。当您点击商品链接时，将直接跳转至对应的电商平台完成购买，我们本身不直接处理交易和支付，确保您的购物安全和便捷。',
  },
];

export const aboutContent = {
  brandName: '亚洲在线',
  tagline: '连接亚洲，精彩在线',
  intro: '亚洲在线成立于2020年，是亚洲领先的数字内容与服务聚合平台。我们致力于连接亚洲各国优质的数字化资源，为用户打造一站式的数字生活入口。',
  mission: '我们的使命是打破信息壁垒，让每一位用户都能轻松获取亚洲各地最新、最优质的数字内容和服务。从影视娱乐到科技资讯，从在线购物到旅行攻略，亚洲在线始终为您汇聚最好的亚洲数字体验。',
  vision: '成为连接亚洲数字生活的最值得信赖的平台，让\"亚洲在线\"成为全球用户了解亚洲、体验亚洲的首选入口。',
  values: [
    { title: '用户至上', description: '始终以用户需求为核心，持续优化产品体验，提供贴心、便捷的服务。' },
    { title: '内容为王', description: '坚持提供高质量、有价值的原创内容，严格筛选合作资源，确保信息准确可靠。' },
    { title: '开放连接', description: '积极连接亚洲各国优秀平台与服务，打造开放共赢的数字生态。' },
    { title: '创新驱动', description: '拥抱技术创新，利用AI和大数据为用户提供个性化的内容推荐和智能服务。' },
  ],
  milestones: [
    { year: '2020', event: '亚洲在线平台正式上线，首批覆盖中日韩三国内容' },
    { year: '2021', event: '拓展至东南亚六国，用户突破500万' },
    { year: '2022', event: '推出个性化AI推荐引擎，用户活跃度提升200%' },
    { year: '2023', event: '新增南亚板块，月活跃用户突破2000万' },
    { year: '2024', event: '获得亚洲数字创新大奖，合作伙伴超过500家' },
    { year: '2025', event: '推出多语言服务，支持中日韩越泰等7种语言' },
    { year: '2026', event: '月活跃用户突破5000万，成为亚洲领先的数字内容平台' },
  ],
  contact: {
    email: 'contact@shangxianrensheng.cn',
    phone: '+86 400-888-6688',
    address: '中国上海市浦东新区陆家嘴金融贸易区世纪大道100号',
    workingHours: '周一至周五 9:00 - 18:00（北京时间）',
  },
};